import { useEffect } from 'react'

/**
 * Flattens the navbar's ground while a bar sits directly under it.
 *
 * The navbar fades its lower edge out to transparent, which leaves a
 * translucent band wherever another fixed bar meets it — the feed's category
 * row, the market page's condensed header. The two read as one block there, so
 * the fading edge only cuts the header in half. This publishes the state the
 * navbar's crossfade is gated on (Navbar.scss).
 *
 * Only one such surface is on screen at a time (the category row is the feed's,
 * the condensed bar the market page's), so a single attribute carries both.
 *
 * @param {boolean} flat - whether the bar is currently showing
 */
const useNavbarFlatGround = flat => {
  useEffect(() => {
    const root = document.documentElement
    root.dataset.navbarGround = flat ? 'flat' : 'faded'

    return () => {
      delete root.dataset.navbarGround
    }
  }, [flat])

  // The attribute above only lands at hydration, so the ground the page starts
  // on would crossfade on load. The transition is armed one frame later and
  // gated on this attribute, the same way LiveStrip arms the top strip offset.
  useEffect(() => {
    const root = document.documentElement
    const armTransition = window.requestAnimationFrame(() => root.setAttribute('data-navbar-ground-ready', ''))

    return () => {
      window.cancelAnimationFrame(armTransition)
      root.removeAttribute('data-navbar-ground-ready')
    }
  }, [])
}

export default useNavbarFlatGround
